import { Trans, useI18next } from 'gatsby-plugin-react-i18next';
import React from 'react';

const Disclaimer = () => {
	const { t } = useI18next();

	return (
		<>
			<div
				className="alert alert-danger bg-warning my-3 border-0 small rounded-0 text-dark"
				role="alert"
			>
				<p className="h6">{t('component_disclaimer:t1')}</p>
				<p className="small">{t('component_disclaimer:t2')}</p>
				<p className="small">
					<Trans i18nKey="component_disclaimer:t3" components={{ a: <a /> }} />
				</p>
				<p className="small">{t('component_disclaimer:t4')}</p>
			</div>
		</>
	);
};

export default Disclaimer;
